import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="site-builder--wizard-launcher"
export default class extends Controller {
  show() {
    const wizard = document.querySelector(".customizable-wizard");
    if (wizard.style.display === "grid") {
      wizard.style.display = "none";
      document.getElementById("launcher-icon").textContent = "settings";
    } else {
      wizard.style.display = "grid";
      document.getElementById("launcher-icon").textContent = "close";
    }
  }
}
